import { render, staticRenderFns } from "./Designer.vue?vue&type=template&id=3708cef6&scoped=true"
import script from "./Designer.vue?vue&type=script&lang=js"
export * from "./Designer.vue?vue&type=script&lang=js"
import style0 from "./Designer.vue?vue&type=style&index=0&id=3708cef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708cef6",
  null
  
)

export default component.exports